
import User from '@/models/User';
import routerManager from '@/routerManagerNew/routerManager';
import Vue from 'vue'
import { mapGetters, mapMutations, mapState } from 'vuex';
import LocationMapCard from "@/components/Map/LocationCard.vue";
import UIButton from '@/components/UI/Button/UIButton.vue';
import DisplayMap from './Map/DisplayMap.vue';
import CloseIcon from './UI/Icons/CloseIcon.vue';

export default Vue.extend({
    props: ["forceEnableDialog"],

    components: {
        "close-icon": CloseIcon,
        "google-map": DisplayMap,
        "location-map-card": LocationMapCard,
        "ui-button": UIButton
    },

    data: () => ({
        addressDialogState: false as boolean,
        isMapDisplayed: false as boolean,
    }),

    computed: {
        ...mapGetters("auth", ["currentSelectedUser"]),
        ...mapState("ui", ["isMobileViewDisplayed"]),

        user(): User {
            return (this as any).currentSelectedUser as User;
        },
    },

    methods: {
        ...mapMutations("auth",["ADD_LOCAL_ADDRESS"]),

        onAddressCreation() {
            routerManager.goToStoresPage();
            this.addressDialogState = false;
        },

        closeDialog() {
            this.addressDialogState = false;
            this.$emit("closeDialog");
        },

        confirmAddress() {
            this.ADD_LOCAL_ADDRESS({
                isDefault: false,
                isAutoDetected: false,
                addressInfo: this.user.usedAddress,
                addressPosition: {lat: this.user.usedAddress.position.latitude, lng: this.user.usedAddress.position.longitude},
            });

            routerManager.goToStoresPage();
            this.addressDialogState = false;
        }
    },

    mounted() {
        this.addressDialogState = this.user.usedAddress.isDefault;
    }
})
